import React from 'react';
import records from '../data.json';
import { Result } from '../../../_metronic/layout/components/DataGrid';
const serverData = records
function DataGridRefund() {
    //define columns
    const columns = React.useMemo(
        () => [
            {
                accessor: "_id",
                Header: "#",
                minWidth: 70,
            },
            {
                accessor: "f",
                Header: "ووچر",
                minWidth: 100,               
            },
            {
                accessor: "Lname",
                Header: "نام و نام خانوادگی",
                minWidth: 180,
            },
            {
                accessor: "tell",
                Header: "موبایل",
                minWidth: 100,
            },
            {
                accessor: "serviceName",
                Header: "نام تفریح",
                minWidth: 180,
            },
            {
                accessor: "date",
                Header: "تاریخ استفاده",
                minWidth: 100,
            },
            {
                accessor: "price",
                Header: "مبلغ رزرو",
                minWidth: 100,
            },
            {
                accessor: "pricfe",
                Header: "مبلغ پرداخت شده",
                minWidth: 140,
            },
            {
                accessor: "datef",
                Header: "زمان ایجاد",
                minWidth: 100,
            },
            {
                Header: 'عملیات',
                accessor: '',
                minWidth: 150,
                align: "center",
                Cell: ({ row: { original } }) => (
                    <div className="text-center">
                        <button
                            className="btn btn-light-info btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-eye text-small'></i>
                            {/* مشاهده */}
                        </button>
                        <button
                            className="btn btn-light-primary btn-sm mr-2 btn-icon"
                        >
                            <i className='far fa-edit text-small'></i>
                            {/* ویرایش */}
                        </button>
                        <button
                            className="btn btn-light-danger btn-sm btn-icon"
                        >
                            <i className='far fa-trash-alt text-small'></i>
                            {/* حذف */}
                        </button>
                    </div>
                )
            }
        ],
        []
    )



    return (
        <div>
            <Result
                columns={columns}
                serverData={serverData}
            />
        </div>
    )
}
export default DataGridRefund;
// class DataGridRefund extends Component {
//     constructor(props) {
//         super(props);
//         this.columns = [
//             {
//                 key: "_id",
//                 text: "#",
//                 width: '70px',
//             },
//             {
//                 key: "_id",
//                 text: "ووچر",
//                 width: '100px',
//             },
//             {
//                 key: "Lname",
//                 text: "نام و نام خانوادگی",
//                 width: '180px',
//             },            
//             {
//                 key: "tell",
//                 text: "موبایل",
//                 width: '100px',
//             },            
//             {
//                 key: "serviceName",
//                 text: "نام تفریح",
//                 width: '180px',
//             },            
//             {
//                 key: "date",
//                 text: "تاریخ استفاده",
//                 width: '100px',
//             },
//             {
//                 key: "price",
//                 text: "مبلغ رزرو",
//                 width: '100px',
//             },
//             {
//                 key: "price",
//                 text: "مبلغ پرداخت شده",
//                 width: '140px',
//             },
//             {
//                 key: "date",
//                 text: "زمان ایجاد",
//                 width: '100px',
//             },


//             {
//                 key: "date",
//                 text: "زمان ایجاد",
//                 width: '100px',
//             },
//             {
//                 key: "action",
//                 text: "",
//                 width: '150px',
//                 className: "text-center action-style",
//                 cell: (record, index) => {
//                     return (
//                         <>
//                             <button
//                                 className="btn btn-light-info btn-sm mr-2 btn-icon"
//                                 onClick={this.editRecord.bind(this, record, index)}>
//                                 <i className='far fa-eye text-small'></i>
//                                 {/* مشاهده */}
//                             </button>
//                             <button
//                                 className="btn btn-light-primary btn-sm mr-2 btn-icon"
//                                 onClick={this.editRecord.bind(this, record, index)}>
//                                 <i className='far fa-edit text-small'></i>
//                                 {/* ویرایش */}
//                             </button>
//                             <button
//                                 className="btn btn-light-danger btn-sm btn-icon"
//                                 onClick={this.deleteRecord.bind(this, record, index)}>
//                                 <i className='far fa-trash-alt text-small'></i>
//                                 {/* حذف */}
//                             </button>
//                         </>
//                     );
//                 }
//             }
//         ];

//         this.config = {
//             page_size: 10,
//             length_menu: [10, 20, 50, 100],
//             show_filter: false,
//             show_pagination: true,
//             pagination: 'advance',
//             button: {
//                 excel: false,
//                 print: false
//             },
//             language: {
//                 length_menu: " _MENU_  رکورد در هر صفحه",
//                 filter: "جستجو ...",
//                 info: " _START_ - _END_ از _TOTAL_ رکورد",
//                 pagination: {
//                     first: "First",
//                     previous: <i className='fa fa-chevron-right'></i>,
//                     next: <i className='fa fa-chevron-left'></i>,
//                     last: "Last"
//                 }
//             }
//         }
//         this.state = {
//             records: records
//         }

//     }
//     editRecord = (record, index) => {
//         console.log("Edit record", index, record);
//     }

//     deleteRecord = (record, index) => {
//         console.log("Delete record", index, record);
//     }
//     render() {
//         return (
//             <ReactDatatable
//                 config={this.config}
//                 records={this.state.records}
//                 columns={this.columns} />
//         );
//     }
// }

// export default DataGridRefund;